import { eventDatesStaffPreperationStatusColorCodeConfig, userStaffStatusColorCodeConfig } from 'components';

export type EventColorCodeOptionType =
  | 'datesStaffPreperation'
  | 'userStaffStatus';

export const eventColorCodeConfigHash = {
  datesStaffPreperation: eventDatesStaffPreperationStatusColorCodeConfig,
  userStaffStatus: userStaffStatusColorCodeConfig,
};